import { Box, Typography, Grid, Paper, Avatar, Stack } from '@mui/material';
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';
import { keyframes } from '@mui/system';

const fadeUp = keyframes`
  from { opacity:0; transform:translateY(24px); }
  to   { opacity:1; transform:translateY(0); }
`;

const testimonials = [
  { name: 'Sekou Camara', role: 'Directeur Sportif — Hafia FC', text: "Depuis que nous utilisons cette plateforme, notre processus de détection de talents a été révolutionné. Nous avons recruté 4 joueurs grâce aux données disponibles.", avatar: 'S' },
  { name: 'Aminata Bah', role: 'Organisatrice — Ligue Régionale', text: "La gestion de nos tournois est devenue un plaisir. Tableaux automatiques, notifications en temps réel, les équipes adorent l'expérience.", avatar: 'A' },
  { name: 'Ousmane Sylla', role: 'Entraîneur — Académie Elite', text: "Les statistiques détaillées m'aident à mieux coacher mes jeunes. Je vois en un coup d'œil qui progresse et qui a besoin d'attention.", avatar: 'O' },
];

const Testimonials = () => (
  <Box sx={{ py: 12, px: 3, background: 'linear-gradient(180deg, #f0fdf4 0%, #ffffff 100%)' }}>
    <Typography variant="overline" sx={{
      letterSpacing: 4, display: 'block', textAlign: 'center', mb: 1,
      background: 'linear-gradient(135deg, #16a34a, #22c55e)',
      WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
      fontWeight: 700,
    }}>
      Témoignages
    </Typography>
    <Typography variant="h2" sx={{ textAlign: 'center', color: '#0f172a', fontWeight: 800, mb: 8, fontSize: { xs: '2rem', md: '3rem' } }}>
      Ils nous font confiance
    </Typography>

    <Grid container spacing={4} maxWidth={1100} mx="auto">
      {testimonials.map((t, i) => (
        <Grid item xs={12} md={4} key={i}>
          <Paper elevation={0} sx={{
            p: 4, height: '100%', bgcolor: '#f8fafc',
            border: '1px solid rgba(34,197,94,.12)', borderRadius: 4,
            animation: `${fadeUp} .7s ease forwards`, animationDelay: `${i * .15}s`, opacity: 0,
            transition: 'all .3s',
            '&:hover': {
              border: '1px solid rgba(34,197,94,.4)',
              boxShadow: '0 8px 32px rgba(34,197,94,.1)',
              transform: 'translateY(-4px)',
            },
          }}>
            <FormatQuoteIcon sx={{
              fontSize: 40, mb: 2, opacity: .7,
              background: 'linear-gradient(135deg, #16a34a, #22c55e)',
              WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
            }} />
            <Typography variant="body1" sx={{ color: '#475569', lineHeight: 1.9, mb: 3, fontStyle: 'italic' }}>
              "{t.text}"
            </Typography>
            <Stack direction="row" spacing={2} alignItems="center">
              <Avatar sx={{
                background: 'linear-gradient(135deg, #22c55e, #16a34a)',
                color: '#fff', fontWeight: 700,
                boxShadow: '0 2px 8px rgba(34,197,94,.3)',
              }}>
                {t.avatar}
              </Avatar>
              <Box>
                <Typography variant="subtitle2" sx={{ color: '#0f172a', fontWeight: 700 }}>{t.name}</Typography>
                <Typography variant="caption" sx={{ color: '#94a3b8' }}>{t.role}</Typography>
              </Box>
            </Stack>
          </Paper>
        </Grid>
      ))}
    </Grid>
  </Box>
);

export default Testimonials;